import { TipoBeca } from './tipoBeca';

export class CicloTipoBeca {

    CicloTipoBecaID: number
    TipoBeca: TipoBeca

}